import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import DataReactTable from "@/containers/Tables/DataTable/components/DataReactTable";
import AddModal from "@/shared/components/AddModal";
import Modal from "@/shared/components/Modal";
import {
  useLazyGetRecordsQuery,
  useDeleteMutation,
} from "@/services/pcApi";
import { ROLE_TYPE_TAG } from "@/shared/tagFile";
import { formateColumnFilter } from "@/utils/columnFilter";
import { successToast } from "@/shared/components/toast";
import RoleTypeForm from "./RoleTypeForm";
import { getAllRoleTypes } from "../../AuthSlice";
import "react-toastify/dist/ReactToastify.css";

const RoleType = () => {
  const [roleTypeDetails, setRoleTypeDetails] = useState();
  const [isOpenAddModal, setIsOpenAddModal] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteRoleType, { isLoading: isDeleting }] = useDeleteMutation();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState([]);
  const [globalSearchKeyword, setGlobalSearchKeyword] = useState(null);
  const [columnFilter, setColumnFilter] = useState({});
  const dispatch = useDispatch();
  const [
    getRoleTypeRecords,
    {
      data: roleTypeList,
      isError: roleTypeError,
      isLoading: roleTypeLoading,
      isFetching: roleTypeFetching,
    },
  ] = useLazyGetRecordsQuery();

  const column = [
    {
      Header: "#",
      accessor: "Id",
      type: "Number",
    },
    {
      Header: "Role Type Name",
      accessor: "Name",
      filter: true,
    },
    {
      Header: "Description",
      accessor: "Description",
      filter: true,
      Cell: ({ value }) => {
        return value ? value : "-";
      },
    },
  ];

  const handleSelectedRecord = (roleTypeData) => {
    setSelectedRecord(roleTypeData);
    setIsOpenAddModal(true);
  };

  const handleDelete = () => {
    deleteRoleType({
      entity: "AuthReference/RoleType",
      id: selectedRecord.Id,
      tag: ROLE_TYPE_TAG,
    }).then((response) => {
      if (!response.error) {
        !isDeleting && setIsOpenDeleteModal(!isOpenDeleteModal);
        successToast("Role-type deleted successfully.");
      }
    });
  };

  useEffect(() => {
    let { filterColumn, filterQuery } = formateColumnFilter(
      column,
      columnFilter
    );

    getRoleTypeRecords({
      entity: "AuthReference/RoleTypes",
      top: pageSize,
      skip: (page - 1) * pageSize,
      sort: sort,
      filter: filterQuery,
      globalFilter: {
        columns: filterColumn,
        globalSearchKeyword: globalSearchKeyword,
      },
      tag: ROLE_TYPE_TAG,
    });
    setRoleTypeDetails({ tableHeaderData: column, tableRowsData: [] });
    // eslint-disable-next-line
  }, [pageSize, page, sort, globalSearchKeyword, columnFilter]);

  useEffect(() => {
    if (
      !roleTypeLoading &&
      !roleTypeError &&
      roleTypeList &&
      !roleTypeFetching
    ) {
      dispatch(getAllRoleTypes(roleTypeList.value));
      let roleTypeData = [...roleTypeList.value];
      setRoleTypeDetails({
        ...roleTypeDetails,
        tableRowsData: roleTypeList.value ? roleTypeData : [],
        totalData:
          roleTypeList && roleTypeList["@odata.count"]
            ? roleTypeList["@odata.count"]
            : 0,
        onEditClick: (data) => handleSelectedRecord(data),
        onDeleteClick: (data) => {
          setIsOpenDeleteModal(true);
          setSelectedRecord(data);
        },
      });
    }
    // eslint-disable-next-line
  }, [roleTypeError, roleTypeList, roleTypeLoading, roleTypeFetching]);

  return (
    <Container>
      <Row>
        {roleTypeDetails && (
          <DataReactTable
            reactTableData={roleTypeDetails}
            onAddClick={() => {
              setIsOpenAddModal(true);
              setSelectedRecord();
            }}
            title="Role Type"
            isFetching={roleTypeFetching}
            setPageNumber={setPage}
            recordsPerPage={pageSize}
            setRecordsPerPage={setPageSize}
            setSort={setSort}
            setGlobalSearchKeyword={setGlobalSearchKeyword}
            setColumnFilter={setColumnFilter}
          />
        )}
      </Row>
      {isOpenAddModal && (
        <AddModal
          toggle={() => setIsOpenAddModal(!isOpenAddModal)}
          color="success"
          title={`${selectedRecord ? "Edit" : "Add"} Role Type`}
          header
          btn="Success"
          message={
            <RoleTypeForm
              editData={selectedRecord ? selectedRecord : {}}
              setIsOpenAddModal={setIsOpenAddModal}
              isOpenAddModal={isOpenAddModal}
            />
          }
        />
      )}
      {isOpenDeleteModal && (
        <Modal
          color="danger"
          title="Delete"
          message={`Are you sure you want to delete ${selectedRecord.Name}?`}
          handleOkClick={() => handleDelete()}
          toggle={() => setIsOpenDeleteModal(!isOpenDeleteModal)}
          isDeleting={isDeleting}
        />
      )}
    </Container>
  );
};

export default RoleType;
